import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import { GlobalStyles } from './styles/GlobalStyles';
import { AuthProvider } from "./contexts/AuthContext";
import ScrollButtons from "./components/Shared/ScrollButtons";
import ProtectedRoute from "./components/Shared/ProtectedRoute";
import DeleteAccount from './pages/DeleteAccount';
// import BlogPage from './pages/BlogPage';
// import ContactPage from './pages/ContactPage';

// Lazy load components
const HomePage = lazy(() => import("./pages/HomePage"));
const AuthPage = lazy(() => import("./pages/AuthPage"));
const Dashboard = lazy(() => import("./components/Dashboard/Dashboard"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const CoursesPage = lazy(() => import("./pages/CoursesPage"));
const MentorsPage = lazy(() => import("./pages/MentorsPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const CourseDetailsPage = lazy(() => import("./pages/CourseDetailsPage"));
const ResourcesPage = lazy(() => import("./pages/ResourcesPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const AppLanding = lazy(() => import("./pages/AppLanding"));

// Loading component
const LoadingFallback = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '100vh',
    background: '#F8FAFC'
  }}>
    <div style={{
      width: '40px',
      height: '40px',
      border: '4px solid #E2E8F0',
      borderTop: '4px solid #4F46E5',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles/>
        <Router>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/about" element={<AboutUs />} /> 
              <Route path="/courses" element={<CoursesPage/>} />
              <Route path="/mentors" element={<MentorsPage />} />
              <Route path="/courses/:courseId" element={<CourseDetailsPage />} />
              <Route path="/resources" element={<ResourcesPage />} />

              {/* Protected Routes */}
              <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
              <Route path="/admin" element={<ProtectedRoute element={<AdminPage />} />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/app" element={<AppLanding />} />
              <Route path="/delete-account" element={<DeleteAccount />} />
              {/* <Route path="/blog" element={<BlogPage />} /> */}
              {/* <Route path="/contact" element={<ContactPage />} /> */}
            </Routes>
          </Suspense>
          <ScrollButtons />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
